// @ts-nocheck
/* eslint-disable */
import { _ } from "~/i18n";
import Scene from "~/scene";
import { node, icon } from "~/util/dom";
import { store } from "~/photo/globals";

/**
 * Button do galerie pro upload fotek
 */
export default class UploadButton {
	constructor(props) {
		this._props = props;

		this._btn = node("button", { className: "gallery-upload-button", type: "button", innerHTML: `<span>${_("gallery.uploadPhoto")}</span>` });
		this._btn.firstChild.before(icon("add-photo2"));
		this._btn.setAttribute("data-log-ignore", "1");
		this._btn.addEventListener("click", this);
	}

	destroy() {
		if (this._btn) {
			this._btn.removeEventListener("click", this);

			this._btn.innerHTML = "";
			this._btn = null;
		}
	}

	get node() {
		return this._btn;
	}

	handleEvent(event) {
		const { longitude, latitude } = store.getState().map;
		const coords = Scene.coordsFromWGS84(longitude, latitude);
		let poi = {
			source: this._props.source === "author" ? Mapy.ImageUploader.NO_POI_SOURCE : this._props.source,
			id: this._props.id ? this._props.id : coords.toWGS84(2).reverse().join(", "),
		}
		let type = this._props.source === "coor" ? "coor" : "poi";

		if (this._props.coords) {
			poi.mark = this._props.coords;
		}

		if (this._props.source === "author") {
			type = "empty";
		}

		let galleryLogData = Mapy.getComponent("gallery").logData;

		Mapy.getComponent("logger").log("click", Object.assign(galleryLogData, {
			origin: "fotky",
			text: _("gallery.uploadPhoto"),
			type: galleryLogData.galleryType == "poi" ? "poi" : "empty",
			source: galleryLogData.galleryType == "poi" ? "mapy-gallery" : "mapy-my_maps",
		}));

		let param = {
			poi,
			source: galleryLogData.galleryType == "poi" ? "mapy-gallery" : "mapy-my_maps",
			type,
		};

		const user = store.getState().user.user;

		if (user.state === "green") {
			Mapy.getComponent("imageUploader").activate().setData(param);
		} else {
			Mapy.getComponent("login").open({
				analyticsData: {
					loginOrigin: "photoUpload",
				},
				motivation: "photo",
			}).then(() => {
				Mapy.getComponent("imageUploader").activate().setData(param);
			}, e => {});
		}
	}
}
